module.exports = __webpack_public_path__ + "static/media/podcast_asthme.a1456b3e.png";